export default
    {
        name :'Sujan Bhattarai.',
        homepageData: ['Hello you found me .','Wellcome!!',],

        contactEmail:'invalidSB45@gmail.com',
        abouttext: "I am a Computer engineering student currently at third year. I have a deep curiosity on Data-Science and Web development. Love to learn new things #peace..",
        aboutImage:'https://pbs.twimg.com/media/Dw7EWPGXcAA11va?format=jpg&name=small',
        ShowAboutImage:true,
        age:22,
       

        service:[
                {
                    id:1,
                    name:'Front-End Development',
                    desc:"I Love to code things from scratch, and enjoy bringing ideas to life in the browser.",
                    icon:'fas fa-paint-brush'
                
                },
                {
                    id:1,
                    name:'Back-End Development',
                    desc:" I really care about backend programming, and love optimizing speed for the users.",
                    icon:'fas fa-code'

                },
                {
                    id:1,
                    name:'Mobile App Development',
                    desc:"Having an experience of 1 years react-native, I can say Building native-app is a fun.",
                    icon:'fas fa-cogs'

                }


        ],

        projects:[
            {
                id: 1,
                title: 'Explore My github',
                imageSrc: "https://cdn.pixabay.com/photo/2020/06/12/14/07/code-5290465_960_720.jpg",
                url: '#'
            },
            { 
                id: 2,
                title: 'Init Develops (BRANDING)',
                imageSrc: "https://cdn.pixabay.com/photo/2019/05/27/22/57/planner-4233907_960_720.jpg",
                url: '#'
                
            },
            {
                id: 3,
                title: 'Website for Organization',
                imageSrc: "https://cdn.pixabay.com/photo/2014/12/08/21/25/business-561388_960_720.jpg",
                url: '#'
           },
            {
                id: 4,
                title: 'Personal Portfolio Website',
                imageSrc: "https://cdn.pixabay.com/photo/2016/01/13/14/23/human-1138004_960_720.jpg",
                url: 'www.invalidsb.me'
            },
            {
                id: 5,
                title: 'TodoApp in React-Native',
                imageSrc: "https://cdn.pixabay.com/photo/2017/06/10/07/18/list-2389219__340.png",
                url: '#'
            },
            {
                id: 6,
                title: 'Recipe Finding Application',
                imageSrc: "https://cdn.pixabay.com/photo/2015/09/16/21/07/egg-943413_960_720.jpg",
                url: '#'
            },
            {
                id: 7,
                title: 'Instagram Like Application',
                imageSrc: "https://cdn.pixabay.com/photo/2016/06/22/22/13/instagram-1474233_960_720.jpg",
                url: '#'
            },
            {
                id: 8,
                title: 'Weather Broadcasting Application',
                imageSrc: "https://cdn.pixabay.com/photo/2016/11/10/08/15/aircraft-1813731_960_720.jpg",
                url: '#'
            }
                
        ],
            skills:[
                {
                    id:1 ,
                    title:"Data Science",
                    desc:"Currently I am interested about machine learning. I've done thesis on DEEP LEARNING in undergrad"
                },
                {
                    id:2 ,
                    title:"Python,",
                    desc:"I really like to know about different programming languges. I know python, java & some more."
                },
                {
                    id:3 ,
                    title:"Photography",
                    desc:" Photography is one of my passion, when i find some time i love to go out with my camera."
                },
                // {
                //     id:4 ,
                //     title:"",
                //     desc:"."
                // }
            ],

        testimonials: [
            {
              id: 1,
              name: "Prerit Bhandari",
              whoami: "Founder of initdevelops",
              image:
                "https://avatars3.githubusercontent.com/u/46107123?s=460&u=c875de430614cd3e98648582db1bb7feae1ed6a8&v=4",
              describe:
                "Sujan is a very enthusiastic learner. I have collabed with him on many projects. Interesting Person. Lorem ipsum,similique cum in dolor? Suscipit quis officiis numquam possimus minus distinctio eveniet corporis expedita in?",
            },
            {
              id: 2,
              name: "Anuj Poudel",
              whoami: "Founder of invocea",
              image:
                "https://avatars2.githubusercontent.com/u/70255790?s=460&u=a321e813dc8fbce1d089d1de222b54b6fe3debab&v=4",
              describe:
              "Sujan is a very enthusiastic learner. I have collabed with him on many projects. Interesting Person. Lorem ipsum,similique cum in dolor? Suscipit quis officiis numquam possimus minus distinctio eveniet corporis expedita in?",
            },
          ],






        social: [
            {   name:'Github',
                url:'https://github.com/invalidsb'},
            {
                name: 'Twitter',
                url: 'https://twitter.com/SujanJa'
            },
            {
                name: 'Instagram',
                url: 'https://www.instagram.com/invalid_sb/'
            }

        ]
    }